import pubsub from "pubsub-js";
// 修改
// pubsub.subscribe('')
const eventKey = "refresh";// 场内刷新
const orderKey = "updateOrder";// 出场订单更新
const parkInKey = "parkIn";// 入场车辆通知
const parkOutKey = "parkOut";// 出场车辆通知
const userInfoKey = "userInfo";// 我的信息通知
const settingKey="setting";// 设置项通知
const realInListKey = "realInList";// 入场车辆通知列表
const realOutListKey = "realOutList";// 出场车辆通知列表
const parkOrderListKey = "parkOrderList";// 订单查询通知列表
const dialogTableKey = "dialogTable";// 订单查询弹窗
const noticeBarKey = "noticeBar";// noticeBar通知
const blaskParkInKey = "blaskParkIn";// 入场车辆通知
const spotNumKey = "spotNum";// 入场车辆通知

// 更新时间通知
export const eventPubSub = {
  publish: function(info) {
    return pubsub.publish(eventKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(eventKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(eventKey)
  }
};
// 订单更新通知
export const orderPubSub = {
  publish: function(info) {
    return pubsub.publish(orderKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(orderKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(orderKey)
  }
};
// 入车通知
export const parkInPubSub = {
  publish: function(info) {
    return pubsub.publish(parkInKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(parkInKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(parkInKey)
  }
};
// 出车通知
export const parkOutPubSub = {
  publish: function(info) {
    return pubsub.publish(parkOutKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(parkOutKey, function(key, msg) {
      // console.log("通知事件--" + key);
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(parkOutKey)
  }
};
// 我的信息
export const userInfoPubSub = {
  publish: function(info) {
    return pubsub.publish(userInfoKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(userInfoKey, function(key, msg) {
      // console.log("通知事件--" + key);
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(userInfoKey)
  }
};
// 设置通知
export const settingPubSub = {
  publish: function(info='') {
    return pubsub.publish(settingKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(settingKey, function(key, msg) {
      // console.log("通知事件--" + key);
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(settingKey)
  }
};
// 入车通知列表
export const realInListPubSub = {
  publish: function(info) {
    return pubsub.publish(realInListKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(realInListKey, function(key, msg) {
      // console.log("通知事件--" + key);
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(realInListKey)
  }
};
// 出车通知列表
export const realOutListPubSub = {
  publish: function(info) {
    return pubsub.publish(realOutListKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(realOutListKey, function(key, msg) {
      // console.log("通知事件--" + key);
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(realOutListKey)
  }
};
// 订单查询通知列表
export const parkOrderListPubSub = {
  publish: function(info) {
    return pubsub.publish(parkOrderListKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(parkOrderListKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(parkOrderListKey)
  }
};
// 订单查询弹窗
export const dialogTablePubSub = {
  publish: function(info) {
    return pubsub.publish(dialogTableKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(dialogTableKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(dialogTableKey)
  }
};
// noticeBar通知
export const noticeBarPubSub = {
  publish: function(info) {
    return pubsub.publish(noticeBarKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(noticeBarKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(noticeBarKey)
  }
};
// 黑名单入车通知
export const blackParkInPubSub = {
  publish: function(info) {
    return pubsub.publish(blaskParkInKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(blaskParkInKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(blaskParkInKey)
  }
};

// 余位通知
export const spotNumPubSub = {
  publish: function(info) {
    return pubsub.publish(spotNumKey, info);
  },
  subscribe: function(callback) {
    return pubsub.subscribe(spotNumKey, function(key, msg) {
      callback(msg);
    });
  },
  unsubscribe: function () {
    return pubsub.unsubscribe(spotNumKey)
  }
};
